var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginKakao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70 -550)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8883",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(70 550)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9300"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 16"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 15"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 29",
    d: "M219.025 167.181c-6.731 0-12.19 4.324-12.19 9.66 0 3.431 2.261 6.437 5.657 8.156l-1.149 4.3a.359.359 0 0 0 .087.368.338.338 0 0 0 .461.019l4.94-3.347a15.28 15.28 0 0 0 2.194.161c6.733 0 12.193-4.324 12.193-9.66s-5.461-9.657-12.193-9.657z",
    transform: "translate(-129.835 391.819)",
    style: {
      fill: "#7833ba"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 17"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30",
    d: "M223.77 214.652h-1.326a.871.871 0 0 1-.471-.125.523.523 0 0 1-.243-.357 1.192 1.192 0 0 1-.019-.137.539.539 0 0 1 .208-.453.826.826 0 0 1 .522-.164h4.059a.865.865 0 0 1 .47.125.529.529 0 0 1 .245.357.6.6 0 0 1 .009.134.554.554 0 0 1-.2.459.813.813 0 0 1-.519.161h-1.326v4.586a.742.742 0 0 1-.192.532.673.673 0 0 1-.514.2.71.71 0 0 1-.449-.145.666.666 0 0 1-.237-.4.77.77 0 0 1-.012-.188z",
    transform: "translate(-142.493 352.476)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 31",
    d: "M249.839 213.094a.635.635 0 0 1 .256-.344.814.814 0 0 1 .431-.1h.336a.882.882 0 0 1 .458.112.74.74 0 0 1 .291.426l1.694 4.927a2.908 2.908 0 0 1 .114.393 1.557 1.557 0 0 1 .026.169.624.624 0 0 1-.2.456.641.641 0 0 1-.467.186.6.6 0 0 1-.63-.4l-.363-1.073h-2.26l-.365 1.073a.586.586 0 0 1-.629.4.652.652 0 0 1-.415-.128.583.583 0 0 1-.215-.363.737.737 0 0 1-.014-.15.853.853 0 0 1 .038-.26c.027-.1.06-.2.1-.3zm.849 1.144h-.018l-.827 2.585h1.643z",
    transform: "translate(-164.771 353.13)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 32",
    d: "M286.6 213.378a.734.734 0 0 1 .192-.529.672.672 0 0 1 .514-.2.7.7 0 0 1 .45.147.669.669 0 0 1 .234.4.707.707 0 0 1 .012.185v4.589h2.345a.842.842 0 0 1 .475.125.536.536 0 0 1 .238.358.921.921 0 0 1 .02.134.546.546 0 0 1-.208.456.83.83 0 0 1-.522.161h-2.93a.933.933 0 0 1-.528-.134.646.646 0 0 1-.265-.437 1.942 1.942 0 0 1-.031-.287z",
    transform: "translate(-197.706 353.13)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33",
    d: "M317.606 213.378a.738.738 0 0 1 .192-.529.674.674 0 0 1 .514-.2.693.693 0 0 1 .449.147.658.658 0 0 1 .236.4.7.7 0 0 1 .014.185v2.132l2.205-2.541a1.517 1.517 0 0 1 .267-.243.531.531 0 0 1 .292-.079.715.715 0 0 1 .42.131.525.525 0 0 1 .233.344l.011.055a.2.2 0 0 0 0 .06.569.569 0 0 1-.065.268 1.258 1.258 0 0 1-.167.235l-1.442 1.581 1.706 2.711.052.082a1.447 1.447 0 0 1 .2.409c0 .005 0 .022.011.043a.227.227 0 0 0 0 .046.643.643 0 0 1-.211.541.807.807 0 0 1-.51.164.694.694 0 0 1-.35-.077.913.913 0 0 1-.276-.306l-1.618-2.612-.77.805.007 1.458a.752.752 0 0 1-.194.532.673.673 0 0 1-.514.2.714.714 0 0 1-.45-.145.666.666 0 0 1-.236-.4.9.9 0 0 1-.012-.188z",
    transform: "translate(-224.093 353.13)",
    style: {
      fill: "#e8cfff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginKakao);
export default __webpack_public_path__ + "static/media/login_kakao.a50f746468357d758990157b5586a7ab.svg";
export { ForwardRef as ReactComponent };